<template>
  <div v-if="volunteer" class="volunteernetmatch">
    <div class="row content">
      <div class="col-lg-4 col-xl-3 mb-3 mb-lg-0 volunteer-area">
        <VolunteerCardNet
          v-model="volunteer"
          :group="group"
          :show-actions="false"
        />
      </div>

      <div class="col-lg-8 col-xl-9 customer-area">
        <div class="row d-lg-none">
          <h4>{{ $t('customerSearch.customerMatchDetails') }}</h4>
        </div>
        <div class="row ml-lg-1 customer-summary">
          <div v-if="customerSelected" class="col">
            <VolunteerMatchSummaryNet
              :group="group"
              :volunteer="volunteer"
              :customer="customer"
              @close="onClose"
              @cancelpending="onCancelPending"
              @activate="onActivate"
              @terminate="onTerminate"
            />
          </div>
          <div v-else class="customer-not-found">
            <font-awesome-icon icon="exclamation-triangle" />{{ $t('customerSearch.matchVolunteerNoLongerExists') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue'
  import * as _ from 'lodash'
  import VolunteerCardNet from './VolunteerCardNet.vue'
  import VolunteerMatchSummaryNet from './VolunteerMatchSummaryNet.vue'
  import { FriendManagementDto, FriendCustomerNetDto, FriendProfileDto, FriendshipNetDto, FriendshipNetCommandCriteria } from '@/types/index'

  export default Vue.extend({
    name: 'VolunteerNetMatchCustomer',
    components: { VolunteerCardNet, VolunteerMatchSummaryNet },
    props: {
      group: {
        type: Object as () => FriendManagementDto,
        required: true
      },
      customer: {
        type: Object as () => FriendCustomerNetDto,
        required: true
      },
      volunteer: {
        type: Object as () => FriendProfileDto,
        required: true
      }
    },
    data () {
      return {
        score: 0,
        isLoading: false,
        isSending: false
      }
    },
    computed: {
      customerSelected (): boolean {
        return !_.isEmpty(this.customer)
      }
    },
    mounted (): void {
      window.scrollTo(0, 0)
    },
    methods: {
      onClose (): void {
        // go back to the matches of the volunteer
        var goto = `/friend/volunteerpreview/${this.group.id}/${this.volunteer.friendInfo.id}`
        this.$router.push(goto)
      },
      onCancelPending (friendship: FriendshipNetDto) {
        var data: FriendshipNetCommandCriteria = this.getNetFriendshipCommandCriteria(friendship)
        var url = `${this.$store.state.apiBases.friendservice + this.$store.state.apiEndpoints.friendshipcancelnet[0]}`
        this.$http.post(url, data).then(resp => {
          this.$emit('oncancelpending')
        })
      },
      onActivate (friendship: FriendshipNetDto) {
        var self = this
        var data: FriendshipNetCommandCriteria = this.getNetFriendshipCommandCriteria(friendship)
        var url = `${this.$store.state.apiBases.friendservice + this.$store.state.apiEndpoints.friendshipactivatenet[0]}`
        this.$http.post(url, data).then(resp => {
          this.$emit('onactivate')
        })
      },
      onTerminate (friendship: FriendshipNetDto) {
        var data: FriendshipNetCommandCriteria = this.getNetFriendshipCommandCriteria(friendship)
        var url = `${this.$store.state.apiBases.friendservice + this.$store.state.apiEndpoints.friendshipterminatenet[0]}`
        this.$http.post(url, data).then(resp => {
          this.$emit('onterminate')
        })
      },
      getNetFriendshipCommandCriteria (friendship: FriendshipNetDto) {
        return {
          groupId: this.group?.id,
          customerProfileNetId: friendship.customerProfileNetId,
          volunteerNetProfileId: friendship.friendVolunteerProfileNetId
        } as FriendshipNetCommandCriteria
      }
    }
  })
</script>

<style lang="scss">
  @import "../../assets/scss/_variables.scss";

  .volunteernetmatch {
    .header {
      margin-top: 10px;
      .nav-header {
        border-bottom: 0;
      }
      h4 {
        padding-left: 10px;
      }
    }
    .content {

      .volunteer-area {
        padding-top: 30px;
        background-color: $brand-white;
        border-left: solid 5px $volunteer-color-strong;
      }

      .customer-area {
        h4 {
          padding-left: 10px;
        }
        .customer-summary {
          @media (min-width: $media-lg) {
            height: 100%;
          }
        }
        .customer-not-found {
          height: 100%;
          text-align: center;
          margin-top: 50px;
          font-weight: bold;
          .fa {
            color: $brand-red;
            margin-right: 5px;
          }
        }
      }
    }
  }
</style>
